import { render, staticRenderFns } from "./EditTableForm.vue?vue&type=template&id=38a201d5&"
import script from "./EditTableForm.vue?vue&type=script&lang=js&"
export * from "./EditTableForm.vue?vue&type=script&lang=js&"
import style0 from "./EditTableForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports